import { useState, useEffect } from 'react';
import { useOrg } from './useOrg';
import { surfaceTypeService } from '../services/surfaceTypeService';
import authService from '../services/authService';

export function useSurfaceTypes({ includeInactive = false } = {}) {
  const { activeOrgId } = useOrg();
  const [surfaceTypes, setSurfaceTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    if (!activeOrgId) return;
    setLoading(true);
    try {
      const all = await surfaceTypeService.getAllSurfaceTypes(activeOrgId);
      if (all.length === 0) {
        const currentUser = authService.getCurrentUser();
        await surfaceTypeService.seedSurfaceTypes(activeOrgId, currentUser?.uid || 'system');
      }
      const list = includeInactive
        ? await surfaceTypeService.getAllSurfaceTypes(activeOrgId)
        : await surfaceTypeService.getSurfaceTypes(activeOrgId);
      setSurfaceTypes(list);
    } catch (err) {
      console.warn('[useSurfaceTypes]', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrgId]);

  return { surfaceTypes, loading, reload: load };
}
